// Shared pdf.js loader. CDN-hosted so we keep a single pdfjs version in flight
// across the app (the document mapper preview and the templates-admin preview
// both use this). The library is cached on `window.pdfjsLib`; the load itself
// is memoised in a module-level promise so concurrent callers share one
// <script> and one worker-setup, and a failed/absent load rejects (rather than
// hanging a spinner forever).
const PDFJS_VERSION = "3.11.174";
export const PDFJS_CDN = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${PDFJS_VERSION}`;

let loaderPromise = null;

export const loadPdfJsLib = () => {
  if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `${PDFJS_CDN}/pdf.min.js`;
    script.async = true;
    script.onload = () => {
      if (window.pdfjsLib) {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = `${PDFJS_CDN}/pdf.worker.min.js`;
        resolve(window.pdfjsLib);
      } else {
        reject(new Error("pdf.js loaded but did not initialise"));
      }
    };
    script.onerror = () => {
      loaderPromise = null; // allow a retry on the next call
      reject(new Error("Failed to load pdf.js"));
    };
    document.head.appendChild(script);
  });
  return loaderPromise;
};

// Build a getDocument loading task with the cMap config that CID/CJK and some
// embedded-subset fonts need to render their glyphs. `source` may be a URL
// string or a getDocument params object (e.g. `{ data: ArrayBuffer }`).
export const getPdfDocument = (pdfjsLib, source) => {
  const params = typeof source === "string" ? { url: source } : { ...source };
  return pdfjsLib.getDocument({
    ...params,
    cMapUrl: `${PDFJS_CDN}/cmaps/`,
    cMapPacked: true,
  });
};
